import { BaseModel } from 'ag-common-lib/lib/models/base.model';

export const EMAIL_PAGE_BUILDER_PATH = 'email-page-builder' as const;

export enum PageBuilderEmailStatus {
  delivered = 'delivered',
  inProgress = 'inProgress',
  cancelled = 'cancelled',
}

export enum PageBuilderEmailKeys {
  phoneNumber = 'phoneNumber',
  firstName = 'firstName',
  lastName = 'lastName',
  to = 'to',
  message = 'message',
  contactEmail = 'contactEmail',
  subjectTitle = 'subjectTitle',
  status = 'status',
}

export class PageBuilderEmail extends BaseModel {
  [PageBuilderEmailKeys.phoneNumber]?: string;
  [PageBuilderEmailKeys.firstName]?: string;
  [PageBuilderEmailKeys.lastName]?: string;
  [PageBuilderEmailKeys.message]?: string;
  [PageBuilderEmailKeys.to]?: string;
  [PageBuilderEmailKeys.contactEmail]?: string;
  [PageBuilderEmailKeys.subjectTitle]?: string;
  [PageBuilderEmailKeys.status]: PageBuilderEmailStatus = PageBuilderEmailStatus.inProgress;
}
